import { render, staticRenderFns } from "./Disapproved.vue?vue&type=template&id=a5c4e3e6"
import script from "./Disapproved.vue?vue&type=script&lang=js"
export * from "./Disapproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports